/**
 * Focus Management Utilities
 * Reusable functions for focus management and focusable element detection
 */

export const getFocusableElements = (container: HTMLElement): HTMLElement[] => {
  const focusableSelectors = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
    '[contenteditable="true"]'
  ].join(', ');

  return Array.from(container.querySelectorAll(focusableSelectors)) as HTMLElement[];
};

export const isElementFocusable = (element: HTMLElement): boolean => {
  // Check if element is visible and not disabled
  if (element.offsetWidth === 0 && element.offsetHeight === 0) return false;
  if (element.hasAttribute('disabled')) return false;
  if (element.getAttribute('aria-disabled') === 'true') return false;
  if (element.getAttribute('tabindex') === '-1') return false;
  
  return true;
};

export const getFirstFocusableElement = (container: HTMLElement): HTMLElement | null => {
  const focusableElements = getFocusableElements(container);
  return focusableElements.find(isElementFocusable) || null;
};

export const getLastFocusableElement = (container: HTMLElement): HTMLElement | null => {
  const focusableElements = getFocusableElements(container);
  const validElements = focusableElements.filter(isElementFocusable);
  return validElements[validElements.length - 1] || null;
};